export default class RetryRequestError extends Error {}
